module.exports = "<h2 id=\"press\">PRESS</h2>\n<p>For press inquiries please contact <u><a href=\"mailto:mail@restaurant-richard.de\">mail@restaurant-richard.de</a></u></p>\n";


//////////////////
// WEBPACK FOOTER
// ./src/assets/copy/press_en.md
// module id = YFuu
// module chunks = 0